<template>
  <v-app>
    <v-main>
      <router-view />
      <app-snackbar />
      <help-button @click="onHelpButtonClick" />
      <help-popup ref="helpPopup" />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { sendEvent } from './services/analytics'
import AppSnackbar from '@/components/AppSnackbar.vue'
import HelpButton from '@/components/HelpButton.vue'
import HelpPopup from '@/components/HelpPopup.vue'
import { useInitStore } from '@/store/app'
import { locale } from '@/plugins/i18n'

const initStore = useInitStore()
const helpPopup = ref()

onMounted(() => {
  if (initStore.locale !== '') {
    locale.value = initStore.locale as 'es' | 'en'
  } else {
    const browserLocale =
      typeof navigator !== 'undefined'
        ? (navigator.languages?.[0] || navigator.language || '').toLowerCase()
        : ''
    locale.value = browserLocale.includes('es') ? 'es' : 'en'
  }
})

const onHelpButtonClick = () => {
  sendEvent('help_button_click')
  helpPopup.value.toggle()
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.v-main {
  background: #f7fcfa;
}

.v-row {
  margin: 0px !important;
}
</style>
